export const get_products = (state,products)=>{
    state.products = products;
}

export const add_product = (state, product) => {
    state.products.unshift({ wharehouse_quantity: 0, ...product });
};

export const update_product = (state, product) => {
    const idx = state.products.findIndex(p => p.id === product.id);
    if (idx !== -1) {
        const existing = state.products[idx];
        state.products.splice(idx, 1, {
            ...existing,
            ...product,
            wharehouse_quantity: existing.wharehouse_quantity,
        });
    }
};

export const remove_product = (state, id) => {
    state.products = state.products.filter(p => p.id !== id);
};

export const set_low_stock = (state, products) => {
    state.low_stock_products = products;
}

export const get_product = (state, product)=> {
    state.product = product;
}
export const get_settings = (state, settings)=> {
    state.settings = settings;
}

export const get_users = (state,users) =>{
    state.users = users;
}

export const get_suppliers = (state,suppliers) =>{
    state.suppliers = suppliers;
}
export const get_categories = (state,categories) =>{
    state.categories = categories;
}

export const get_customers = (state ,customers) =>{
    state.customers = customers
}

//getting the wharehouses
export const get_wharehouses =(state, wharehouses) =>{
    state.wharehouses = wharehouses;
}

//the contents of the wharehouses
export const wharehouse_items =(state, items) => {
    state.witems = items
}

export const get_transfers = (state, transfers) => {
    state.transfers = transfers;
}

export const get_pos_warehouses = (state, warehouses) => {
    state.pos_warehouses = warehouses;
}
export const get_purchases =(state, purchases) =>{
    state.purchases = purchases;
}

export const get_expenses = (state, expenses)=>{
    
    state.expenses = expenses;
}

export const get_expense_category = (state, expense_category) =>{

    state.expense_category = expense_category;
}

export const get_departments = (state, departments) =>{
    state.departments = departments;
}

export const get_personels = (state, personels) =>{
    state.personels = personels;
}

export const get_mainchart = (state, mainchart) =>{
    state.mainchart = mainchart;
}

//sidebar mutations

export const toggleSidebarDesktop = (state) => {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
}
export const toggleSidebarMobile = (state) => {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
}
export const set = (state, [variable, value]) => {
    state[variable] = value
  }